import React from "react";
import PropTypes from "prop-types";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./MinimumPaymentAmountAlert.css";

export default class MinimumPaymentAmountAlert extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    minimumPaymentAmount: PropTypes.number.isRequired
  }

  static defaultProps = {
    isOpen: true
  }

  onOKClick = () => {
    this.props.onClose(true);
  }

  render() {
    const { isOpen, minimumPaymentAmount} = this.props;
    return (
      <ModalDialog isOpen={isOpen}>
        <div>
          <div className="minimum-payment-amount__title">Alert</div>
          <div className="minimum-payment-amount__message">Please make your payment at least £{minimumPaymentAmount/100}</div>
          <div className="minimum-payment-amount__button-container">
            <Button className="minimum-payment-amount__ok-button" onClick={this.onOKClick}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/school_money/basket/MinimumPaymentAmountAlert.js